import { css } from '@emotion/react';
import type { ShortRule } from 'shared';

import { SasIcon } from './SasIcon';
import { theme } from './theme';

const styles = {
  container: (displayIcons: boolean) => css`
    display: flex;
    flex-direction: column;
    margin-top: ${theme.spacing.sm};
    gap: ${displayIcons ? theme.spacing.xs : 0};
  `,
  fareRuleText: css`
    font-size: ${theme.fontSize.xs};
  `,
  marginBottomSm: css`
    margin-bottom: ${theme.spacing.sm};
    text-transform: uppercase;
  `,
  rule: css`
    display: flex;
    gap: ${theme.spacing.xs};
    align-items: center;
  `,
};

type Props = {
  cabinClassName: string;
  shortRules: ShortRule[] | undefined;
  includedShortRules?: string[];
  displayIcons?: boolean;
};

export function CabinClassAndShortRules({
  cabinClassName,
  shortRules,
  includedShortRules,
  displayIcons = false,
}: Props) {
  const shortRulesToInclude = includedShortRules || ['rebook', 'refund'];
  const cabinClass = cabinClassName.toUpperCase();

  const shortRulesToDisplay = shortRules?.filter(rule =>
    shortRulesToInclude.some(shortRule => rule.id.toLowerCase().includes(shortRule))
  );

  return (
    <div css={styles.container(displayIcons)}>
      <span css={displayIcons && styles.marginBottomSm}>{cabinClass}</span>
      {shortRulesToDisplay?.map(({ id, iconName, text }) => (
        <div key={id} css={styles.rule}>
          {displayIcons && <SasIcon name={iconName} />}
          <span css={styles.fareRuleText}>{text}</span>
        </div>
      ))}
    </div>
  );
}
